import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_life" },
  { title: "menu_sidebar_health_plan_setup" },
  { title: "menu_sidebar_health_plan_setup_b2c" },
  { title: "menu_sidebar_health_plan_setup_b2c_shelf_plans", link: "/life/plan-setup/b2c/shelf-plans" }
];

const ShelfPlanListing = Loadable({
  loader: () => import("container/life/planSetup/b2c/shelfPlans/listing"),
  loading() {
    return <Loader />;
  }
});
const ShelfPlanAdd = Loadable({
  loader: () => import("container/life/planSetup/b2c/shelfPlans"),
  loading() {
    return <Loader />;
  }
});
const ServicesEdit = Loadable({
  loader: () => import("container/life/planSetup/b2c/shelfPlans/services/editServices"),
  loading() {
    return <Loader />;
  }
});

export const healthShelfPlanB2CRoutes: IRoute[] = [
  {
    path: "/life/plan-setup/b2c/shelf-plans",
    element: <ShelfPlanListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/life/plan-setup/b2c/shelf-plans/details/:id?",
    element: <ShelfPlanAdd />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  },
  {
    path: "/life/plan-setup/b2c/shelf-plans/services/details",
    element: <ServicesEdit />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_health_plan_setup_b2c_customized_plans" }]
    }
  }
];
